module.exports = __webpack_public_path__ + "static/media/CSM146.9a06cb23.PNG";